import { render, staticRenderFns } from "./UserCreateView.vue?vue&type=template&id=4ff230d2&"
import script from "./UserCreateView.vue?vue&type=script&lang=js&"
export * from "./UserCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports